import { from } from 'rxjs';
import { filter } from 'rxjs/operators';
import {
  BROADCAST_CREATE_BACKGROUND,
  BROADCAST_BACKGROUND_SCAN,
} from '@shoflo/studio-redux/actions/types';

import { toggleBackgroundHidden } from '@shoflo/studio-redux/actions';

function createdBackgroundMiddleware() {
  return (store) => (next) => async (action) => {
    const targetActions = [
      `${BROADCAST_CREATE_BACKGROUND}_SUCCESS`,
      `${BROADCAST_BACKGROUND_SCAN}_SUCCESS`,
    ];
    from([action])
      .pipe(filter(($action) => targetActions.includes($action.type)))
      .subscribe(($action) => {
        if (targetActions.includes($action.type) && $action.payload) {
          const { dispatch } = store;
          dispatch(toggleBackgroundHidden($action.payload[0]._id, true));
        }
      });

    return next(action);
  };
}

export default createdBackgroundMiddleware;
